/**
 * Dostepne rodzaje działalności merchanta p24
 */
export const P24MerchantBusinessType = {

    _0: {
        id: 0,
        name: '_0',
        displayText: 'Brak',
        isNipRequired: false,
        isPeselRequired: false,
        isRegonRequired: false,
        isKrsRequired: false,
        isRepresentativeRequired: false
    },
    _1: {
        id: 1,
        name: '_1',
        displayText: 'Osoba fizyczna',
        isNipRequired: false,
        isPeselRequired: true,
        isRegonRequired: false,
        isKrsRequired: false,
        isRepresentativeRequired: false
    },
    _2: {
        id: 2,
        name: '_2',
        displayText: 'Jednoosobowa działalność gospodarcza',
        isNipRequired: true,
        isPeselRequired: false,
        isRegonRequired: true,
        isKrsRequired: false,
        isRepresentativeRequired: true
    },
    _3: {
        id: 3,
        name: '_3',
        displayText: 'Spółka cywilna',
        isNipRequired: true,
        isPeselRequired: false,
        isRegonRequired: true,
        isKrsRequired: false,
        isRepresentativeRequired: true
    },
    _4: {
        id: 4,
        name: '_4',
        displayText: 'Spółka jawna',
        isNipRequired: true,
        isPeselRequired: false,
        isRegonRequired: true,
        isKrsRequired: true,
        isRepresentativeRequired: true
    },
    _5: {
        id: 5,
        name: '_5',
        displayText: 'Spółka komandytowa',
        isNipRequired: true,
        isPeselRequired: false,
        isRegonRequired: true,
        isKrsRequired: true,
        isRepresentativeRequired: true
    },
    _6: {
        id: 6,
        name: '_6',
        displayText: 'Spółka komandytowo-akcyjna',
        isNipRequired: true,
        isPeselRequired: false,
        isRegonRequired: true,
        isKrsRequired: true,
        isRepresentativeRequired: true
    },
    _7: {
        id: 7,
        name: '_7',
        displayText: 'Spółka akcyjna',
        isNipRequired: true,
        isPeselRequired: false,
        isRegonRequired: true,
        isKrsRequired: true,
        isRepresentativeRequired: true
    },
    _8: {
        id: 8,
        name: '_8',
        displayText: 'Spółka z ograniczoną odpowiedzialnością',
        isNipRequired: true,
        isPeselRequired: false,
        isRegonRequired: true,
        isKrsRequired: true,
        isRepresentativeRequired: true
    },
    _9: {
        id: 9,
        name: '_9',
        displayText: 'Stowarzyszenie, fundacja, organizacja pożytku publicznego',
        isNipRequired: true,
        isPeselRequired: false,
        isRegonRequired: true,
        isKrsRequired: true,
        isRepresentativeRequired: true
    },
    _10: {
        id: 10,
        name: '_10',
        displayText: 'Spółdzielnia',
        isNipRequired: true,
        isPeselRequired: false,
        isRegonRequired: true,
        isKrsRequired: true,
        isRepresentativeRequired: true
    },

}

/**
 * Kolekcja typow
 */
export const P24MerchantBusinessTypeList = Object.keys(P24MerchantBusinessType).map(type => P24MerchantBusinessType[type])

/**
 * Metoda zwracająca typ działalności bazując na identyfikatorze
 * 
 * @param {int} id identyfikator typu działalności
 * 
 * @returns {P24MerchantBusinessType} typ działalności
 */
export const getP24MerchantBusinessTypeById = (id) => {

    if (id == null) {
        // Do stuff, will only match null or undefined, this won't match false
        return P24MerchantBusinessType._0;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let businessType = P24MerchantBusinessTypeList.find(item => item.id === id)
    return businessType;
}

/**
 * Metoda zwracająca typ działalności bazując na nazwie
 * 
 * @param {String} name nazwa typu działalności
 * 
 * @returns {P24MerchantBusinessType} typ działalności
 */
export const getP24MerchantBusinessTypeByName = (name) => {
    if (!name) {
        return P24MerchantBusinessType._1;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let businessType = P24MerchantBusinessTypeList.find(item => item.name === name)
    return businessType;
}